import { User } from 'src/models/User';
import { swrFetch } from 'src/utils/swrFetch';
import useSWR from 'swr';

export const useUser = (id: number) => {
    return useSWR<User>(id && !isNaN(id) ? `/users/${id}` : null, swrFetch);
};
